
// This helper provides support for model sharing between presenters
var ModelRepository = function() {

    //we keep the models here
    var _models = {},
        _subscriberCount = {};

    //converts keys to arrays
    var _2array = function(key) {
        //we split by `:` if we receive a string, else we assume we got an array
        return (typeof key === 'string') ? key.split(':') : key;
    };

    //return the container of the last key. if key is `"a:b:c"` return `{"c":<something>}`
    var _getLeafContainer = function(keys) {
        //we cache the length of the key array
        var keyLength = keys.length,
            key,
            container = _models,
            i = 0;

        //we iterate through the keys, creating all the intermediate levels, if they don't already exist
        for (; i < keyLength; i++) {
            key = keys[i];
            container[key] = container[key] || {};
            container = container[key];
        }

        return container;
    };

    //add a subscriber to a key. Subscriptions don't care about key structure,
    //subscribing to a parent key **does not** subscribe the children of that key.
    var _addSubscriber = function(key){
       _subscriberCount[key] = (_subscriberCount[key] || 0) + 1;
    };

    //we remove the subscriber and return the number of subscribers remaining
    var _removeSubscriber = function(key){
       var count = (_subscriberCount[key] || 0) - 1;

       if(count <= 0){
          delete _subscriberCount[key];
       } else {
          _subscriberCount[key] = count;
       }

       return count;
    };

    return {
        addModel: function(key, model) {
            var keyParts = _2array(key),
                leafKey = keyParts.pop();

            window.console.log('Model Repository: Adding model with key '+key);
            //we attach the model to the _leaf_ key
            _getLeafContainer(keyParts)[leafKey] = model;
        },
        getModels: function(key) {
            var keyParts = _2array(key),
                leafKey = keyParts.pop();

            return _getLeafContainer(keyParts)[leafKey];
        },
        removeModels: function(key) {
            var keyParts = _2array(key),
                leafKey = keyParts.pop();

            window.console.log('Model Repository: Removing model with key '+key);
            delete _getLeafContainer(keyParts)[leafKey];
            delete _subscriberCount[key];
        },

        add_and_subscribe: function(key, model) {
           this.addModel(key, model);

           _addSubscriber(key);
        },

        get_and_subscribe: function(key) {
           var model = this.getModels(key);

           if( model ) _addSubscriber(key);

           return model;
        },
        release: function(key){
           if(_removeSubscriber(key) <= 0){
              this.removeModels(key);
           }
        },

        // we empty the model repo
        resetRepo: function() {
            window.console.log('Model Repository: Resetting model...');
           _models = {};
           _subscriberCount = {};
        }
    };
};

export default ModelRepository;
